<template>
  <div class="b-line-chart">
    <div class="b-line-chart__filters">
      <filters
        :filters-data="filtersData"
        :active-filter="activeFilter"
        :from-label="fromLabel"
        :to-label="toLabel"
        :date-from="dateFrom"
        :date-to="dateTo"
        :re-init-pickers="reInitPickers"
        @changed-duration="getNewSelectedFilter"
        @changed-date="getDates">        
        </filters>

      <div class="b-line-chart__col">
        <line-chart
          :labels="chartData.labels"
          :datasets="chartData.datasets"
          :type="type"
          :pdf="chartData.pdf"
          :graph-update-counter="graphUpdateCounter"
          ></line-chart>
      </div>

      <div
        v-if="chartData.pdf" class="b-line-chart__download-pdf b-line-chart__col">
        <a :href="chartData.pdf.url" download class="btn btn-icon-outline-blue">
          <span>{{ chartData.pdf.label }}</span>
        </a>
      </div>

      <div v-if="chartData.legend" class="b-chart-legend">
        <ul>
          <li v-for="(legend, index) in chartData.legend" :key="index">
            <div
              class="b-chart-legend__color"
              :style="{
                'background-color': chartData.datasets[index].borderColor,
              }"></div>
            <div class="b-chart-legend__name">{{ legend }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from './Filters.vue'
import LineChart from './Line-chart.vue'

export default {
  components: {
    Filters,
    LineChart,
  },
  props: {
    reInitPickers: {
      required: true,
      type: Boolean,
    },
    filtersData: {
      required: true,
      type: Object,
    },
    activeFilter: {
      required: true,
      type: String,
    },
    chartData: {
      required: true,
      type: Object,
    },
    // datasets: {
    //   required: true,
    //   type: Array,
    // },
    fromLabel: {
      type: String,
      default: '',
    },
    toLabel: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
    graphUpdateCounter:{
      type:Number,
      default:0
    },
    type:{
      type:String,
      required:true
    }
  },
  emits: ['changed-duration', 'changed-date'],
  methods: {
    getNewSelectedFilter(activeId) {
      this.$emit('changed-duration', activeId)
    },
    getDates(dates) {     
      this.$emit('changed-date', dates)
    },
  },
}
</script>
